// @ts-nocheck
import { Input } from "antd";
import { h } from "preact";
interface IForm {
  defaultValue?: any;
  options?: any;
}

export const FORM_SEARCH = ({ options = [], onSubmitSearch }: any) => {
  return [
    {
      ref: "search_id",
      name: "search_id",
      id: "search_id",
      type: "INPUT",
      label: "หมายเลขเครื่องตัด",
      placeholder: "ตัวอย่าง TG1234567890",
      span: 6,
      onEnter: onSubmitSearch,
    },
    {
      ref: "search_name_customerid",
      name: "search_name_customerid",
      label: "รหัสลูกค้า / ชื่อลูกค้า",
      type: "INPUT",
      placeholder: "ตัวอย่าง PL22040304",
      span: 6,
      onEnter: onSubmitSearch,
    },
    {
      ref: "search_repair",
      name: "search_repair",
      label: "ผู้ที่รับงาน / ผู้ที่แจ้งซ่อม",
      type: "INPUT",
      placeholder: "ตัวอย่าง PL22040304",
      span: 6,
      onEnter: onSubmitSearch,
    },
    {
      ref: "search_track",
      name: "search_track",
      label: "Tracking No.",
      type: "INPUT",
      placeholder: "ตัวอย่าง PL22040304",
      span: 6,
      onEnter: onSubmitSearch,
    },
    {
      ref: "search_repairstartdate",
      name: "search_repairstartdate",
      label: "วันที่แจ้งซ่อม",
      type: "DATEPICKER",
      placeholder: "เลือกวัน",
      span: 6,
    },
    {
      ref: "search_repairenddate",
      name: "search_repairenddate",
      label: "วันที่สิ้นสุด",
      placeholder: "เลือกวัน",
      type: "DATEPICKER",
      span: 6,
    },
    {
      ref: "search_status_device",
      name: "search_status_device",
      label: "สถานะ",
      type: "SELECT",
      span: 6,
      properties: {
        options: options,
        valueKey: "value",
        labelKey: "label",
      },
    },
  ];
};

export const FORM_MAINTENANCE_DATA = ({ defaultValue = "" }: IForm) => {
  return [
    {
      ref: "deviceId",
      name: "deviceId",
      id: "deviceId",
      type: "INPUT",
      label: "หมายเลขเครื่่องตัด",
      placeholder: "ตัวอย่าง TG1234567890",
      span: 8,
      defaultValue,
      rules: {
        required: {
          value: true,
          message: "กรุณากรอกหมายเลขเครื่่องตัด",
        },
      },
      // disabled: true,
    },
    {
      ref: "maintainType",
      name: "maintainType",
      label: "ลักษณะเครื่อง",
      type: "INPUT",
      placeholder: "ตัวอย่าง PL22040304",
      span: 8,
      defaultValue,
      disabled: true,
    },
    {
      ref: "customerCode",
      name: "customerCode",
      label: "รหัสลูกค้า",
      type: "INPUT",
      placeholder: "ตัวอย่าง PL22040304",
      span: 8,
      defaultValue,
      // disabled: true,
    },
    {
      ref: "customerName",
      name: "customerName",
      label: "ชื่อลูกค้า",
      type: "INPUT",
      placeholder: "เลือกวัน",
      span: 8,
      defaultValue,
      rules: {
        required: {
          value: true,
          message: "กรุณากรอกชื่อลูกค้า",
        },
      },
      // disabled: true,
    },
    {
      ref: "createDate",
      name: "createDate",
      label: "วันที่แจ้ง",
      placeholder: "เลือกวัน",
      type: "DATEPICKER",
      span: 8,
      defaultValue,
      disabled: true,
      properties: {
        showTime: true,
      },
    },
    {
      ref: "saleCode",
      name: "saleCode",
      label: "ผู้ที่แจ้งซ่อม",
      placeholder: "ผู้ที่แจ้งซ่อม",
      type: "INPUT",
      span: 8,
      defaultValue,
      disabled: true,
    },
    // {
    //   ref: "maintainStatusId",
    //   name: "maintainStatusId",
    //   label: "สถานะ",
    //   type: "SELECT",
    //   span: 8,
    //   disabled,
    //   properties: {
    //     options: options,
    //     valueKey: "value",
    //     labelKey: "label",
    //   },
    // },
    // {
    //   ref: "remark",
    //   name: "remark",
    //   label: "หมายเหตุ",
    //   type: "TEXTAREA",
    //   span: 16,
    //   disabled,
    // },
  ];
};

export const FORM_MAINTENANCE_LINE = (maintenanceLine: any) => {
  const totalMainTenance: any = [];
  if (maintenanceLine.length) {
    for (const e of maintenanceLine) {
      if (e.fieldCode === "DELIVERY-SALE") {
        totalMainTenance.push(
          {
            ref: "main_transit",
            name: "main_transit",
            label: "ช่องทางการขนส่ง",
            placeholder: "ช่องทางการขนส่ง",
            type: "INPUT",
            span: 12,
          },
          {
            ref: "main_transit_number",
            name: "main_transit_number",
            label: "หมายเลขขนส่ง",
            placeholder: "หมายเลขขนส่ง",
            type: "INPUT",
            span: 12,
          }
        );
      }
    }
    return totalMainTenance;
  } else {
    return [];
  }
};

export const FORM_MAINTENANCE_CONFIRM_GET_JOB = () => {
  return [
    {
      ref: "main_confirm_worker",
      name: "main_confirm_worker",
      id: "main_confirm_worker",
      type: "INPUT",
      label: "ผู้รับงาน",
      placeholder: "ตัวอย่าง นายกิติเมจ แก้วมงคล",
      span: 12,
      disabled: true,
    },
    {
      ref: "main_confirm_start_date",
      name: "main_confirm_start_date",
      label: "วันที่แจ้งซ่อม",
      type: "INPUT",
      span: 12,
      disabled: true,
    },
    {
      ref: "main_confirm_remark",
      name: "main_confirm_remark",
      label: "หมายเหตุ / คอมเมนต์",
      type: "TEXTAREA",
      span: 24,
    },
  ];
};

export const FORM_MAINTENANCE_TECH_CONFIRM_GET_JOB = () => {
  return [
    {
      ref: "main_name_tech",
      name: "main_name_tech",
      id: "main_name_tech",
      type: "INPUT",
      label: "ชื่อช่างที่ซ่อม",
      span: 12,
      disabled: true,
    },
    {
      ref: "main_confirm_start_date",
      name: "main_confirm_start_date",
      label: "วันที่แจ้งซ่อม",
      type: "INPUT",
      placeholder: "ตัวอย่าง 2022-04-01 12:03:51",
      span: 12,
      disabled: true,
    },
    {
      ref: "main_confirm_remark",
      name: "main_confirm_remark",
      label: "หมายเหตุ / คอมเมนต์",
      type: "TEXTAREA",
      span: 24,
    },
  ];
};

export const FORM_MAINTENANCE_TECH_END_JOB = ({
  isMachine,
  onCallbackEditService,
  onCallbackEditSparePart,
  optionsSpar = [],
  optionsService = [],
}: any) => {
  return [
    {
      ref: "main_endjob_name_tech",
      name: "main_endjob_name_tech",
      id: "main_endjob_name_tech",
      type: "INPUT",
      label: "ชื่อช่างที่ซ่อม",
      span: 12,
      disabled: true,
      rules: {
        required: {
          value: true,
          message: "กรุณากรอกชื่อช่างที่ซ่อม",
        },
      },
    },
    {
      ref: "versionMachine",
      name: "versionMachine",
      id: "versionMachine",
      label: "version เครื่องตัด",
      type: "INPUT",
      span: 12,
      disabled: true,
    },
    {
      ref: "main_endjob_tech_start_date",
      name: "main_endjob_tech_start_date",
      id: "main_endjob_tech_start_date",
      label: "วันที่แจ้งซ่อม",
      type: "INPUT",
      span: 12,
      disabled: true,
      rules: {
        required: {
          value: true,
          message: "กรุณากรอกวันที่แจ้งซ่อม",
        },
      },
    },
    {
      ref: "main_endjob_tech_start_repair_date",
      name: "main_endjob_tech_start_repair_date",
      id: "main_endjob_tech_start_repair_date",
      label: "วันที่เริ่มซ่อม",
      type: "INPUT",
      span: 12,
      disabled: true,
      rules: {
        required: {
          value: true,
          message: "กรุณากรอกวันที่เริ่มซ่อม",
        },
      },
    },
    {
      ref: "main_endjob_tech_end_repair_date",
      name: "main_endjob_tech_end_repair_date",
      id: "main_endjob_tech_end_repair_date",
      label: "วันที่ซ่อมเสร็จ",
      type: "INPUT",
      span: 12,
      disabled: true,
      rules: {
        required: {
          value: true,
          message: "กรุณากรอกวันที่ซ่อมเสร็จ",
        },
      },
    },
    {
      ref: "main_endjob_tech_end_link_video",
      name: "main_endjob_tech_end_link_video",
      id: "main_endjob_tech_end_link_video",
      label: "ลิ้งค์วิดีโอหลักฐานการซ่อม",
      type: "INPUT",
      span: 24,
      rules: {
        required: {
          value: true,
          message: "กรุณากรอกลิ้งค์วิดีโอหลักฐานการซ่อม",
        },
        pattern: {
          value:
            /^(https?:\/\/)?([\wก-๙.-]+(\.[\wก-๙.-]+)+)(:\d+)?(\/[\wก-๙@%&?+=:~.-]*)*(\?[\wก-๙@%&+=.-]*)?(#[\wก-๙-]*)?$/,
          message: "รูปแบบลิ้งค์ไม่ถูกต้อง",
        },
      },
    },
    {
      ref: "main_endjob_tech_spare_part",
      name: "main_endjob_tech_spare_part",
      id: "main_endjob_tech_spare_part",
      label: "อะไหล่ที่ใช้",
      type: "SELECT_MODAL",
      span: 24,
      properties: {
        options: optionsSpar,
        valueKey: "sparePartId",
        labelKey: "sparePartName",
        columns: ({ onChangeText }) => [
          {
            title: "ชื่อ",
            dataIndex: "sparePartName",
            key: "sparePartName",
            width: "5em",
          },
          {
            title: "จำนวน",
            dataIndex: "qty",
            key: "qty",
            width: "4em",
            render: (text: string, _record) => {
              return (
                <Input
                  value={text}
                  defaultValue={1}
                  onChange={(e) => onChangeText(e, _record, "qty")}
                />
              );
            },
          },
          {
            title: "ราคา",
            dataIndex: "price",
            key: "price",
            width: "10em",
            render: (text: string, _record) => {
              return (
                <Input
                  value={text}
                  onChange={(e) => onChangeText(e, _record, "price")}
                />
              );
            },
          },
        ],
      },
      onCallbackEdit: onCallbackEditSparePart,
    },
    isMachine && {
      ref: "main_endjob_deviceId",
      name: "main_endjob_deviceId",
      id: "main_endjob_deviceId",
      label: "หมายเลขเครื่องใหม่",
      type: "INPUT",
      span: 24,
      rules: {
        required: {
          value: true,
          message: "กรุณากรอกหมายเลขเครื่องใหม่",
        },
      },
    },
    {
      ref: "main_endjob_tech_service",
      name: "main_endjob_tech_service",
      id: "main_endjob_tech_service",
      label: "ค่าบริการด้านอื่น ๆ",
      type: "SELECT_MODAL",
      span: 24,
      properties: {
        options: optionsService,
        valueKey: "serviceId",
        labelKey: "serviceName",
        columns: ({ onChangeText }) => [
          {
            title: "ชื่อ",
            dataIndex: "serviceName",
            key: "serviceName",
            width: "5em",
          },
          {
            title: "ราคา",
            dataIndex: "price",
            key: "price",
            width: "10em",
            render: (text: string, record) => {
              return (
                <Input
                  value={text}
                  onChange={(e) => onChangeText(e, record, "price")}
                />
              );
            },
          },
        ],
      },
      onCallbackEdit: onCallbackEditService,
    },
    {
      ref: "main_endjob_damage",
      name: "main_endjob_damage",
      id: "main_endjob_damage",
      label: "สาเหตุการเสีย",
      type: "TEXTAREA",
      span: 24,
      rules: {
        required: {
          value: true,
          message: "กรุณากรอกสาเหตุการเสีย",
        },
      },
    },
    {
      ref: "main_endjob_remark",
      name: "main_endjob_remark",
      id: "main_endjob_remark",
      label: "หมายเหตุ / คอมเมนต์",
      type: "TEXTAREA",
      span: 24,
    },
  ];
};

export const FORM_END_JOB_REPAIR = ({ deliveryOptions = [] }) => {
  return [
    {
      ref: "userId",
      name: "userId",
      id: "userId",
      type: "INPUT",
      label: "ชื่อผู้ปิดจบงาน",
      span: 12,
      disabled: true,
    },
    {
      ref: "versionMachine",
      name: "versionMachine",
      id: "versionMachine",
      label: "version เครื่องตัด",
      type: "INPUT",
      span: 12,
      disabled: true,
    },
    {
      ref: "createDate",
      name: "createDate",
      id: "createDate",
      label: "วันที่แจ้งซ่อม",
      type: "INPUT",
      span: 12,
      disabled: true,
    },
    {
      ref: "main_endjob_delivery",
      name: "main_endjob_delivery",
      id: "main_endjob_delivery",
      label: "ประเภทขนส่ง",
      type: "SELECT",
      span: 12,
      rules: {
        required: {
          value: true,
          message: "กรุณากรอกประเภทขนส่ง",
        },
      },
      properties: {
        options: deliveryOptions,
        valueKey: "deliveryId",
        labelKey: "deliveryName",
      },
    },
    {
      ref: "main_endjob_tracking",
      name: "main_endjob_tracking",
      id: "main_endjob_tracking",
      label: "Tracking No.",
      type: "INPUT",
      span: 12,
      rules: {
        required: {
          value: true,
          message: "กรุณากรอก Tracking No.",
        },
      },
    },
    {
      ref: "main_endjob_remark",
      name: "main_endjob_remark",
      id: "main_endjob_remark",
      label: "หมายเหตุ / คอมเมนต์",
      type: "TEXTAREA",
      span: 24,
    },
  ];
};

export const DETAIL_MAINTENANCE_TECH_END_JOB = () => {
  return [
    {
      ref: "main_endjob_name_tech",
      name: "main_endjob_name_tech",
      id: "main_endjob_name_tech",
      type: "INPUT",
      label: "ชื่อช่างที่ซ่อม",
      span: 12,
      disabled: true,
    },
    {
      ref: "createDate",
      name: "createDate",
      id: "createDate",
      label: "วันที่แจ้งซ่อม",
      type: "DATEPICKER",
      span: 12,
      disabled: true,
      properties: {
        showTime: true,
      },
    },
    {
      ref: "main_endjob_tech_start_repair_date",
      name: "main_endjob_tech_start_repair_date",
      id: "main_endjob_tech_start_repair_date",
      label: "วันที่เริ่มซ่อม",
      type: "INPUT",
      span: 12,
      disabled: true,
    },
    {
      ref: "main_endjob_tech_end_repair_date",
      name: "main_endjob_tech_end_repair_date",
      id: "main_endjob_tech_end_repair_date",
      label: "วันที่ซ่อมเสร็จ",
      type: "INPUT",
      span: 12,
      disabled: true,
    },
    {
      ref: "linkVideo",
      name: "linkVideo",
      id: "linkVideo",
      label: "ลิ้งค์วิดีโอหลักฐานการซ่อม",
      type: "LINK_URL",
      span: 24,
      disabled: true,
    },
    {
      ref: "spares",
      name: "spares",
      id: "spares",
      label: "อะไหล่ที่ใช้",
      type: "SELECT_MODAL",
      span: 24,
      disabled: true,
      properties: {
        options: [],
        columns: () => [],
      },
    },
    {
      ref: "main_endjob_delivery",
      name: "main_endjob_delivery",
      id: "main_endjob_delivery",
      label: "ประเภทขนส่ง",
      type: "INPUT",
      span: 12,
      disabled: true,
    },
    {
      ref: "main_endjob_tracking",
      name: "main_endjob_tracking",
      id: "main_endjob_tracking",
      label: "Tracking No.",
      type: "INPUT",
      span: 12,
      disabled: true,
    },
    {
      ref: "services",
      name: "services",
      id: "services",
      label: "อะไหล่ที่ใช้",
      type: "SELECT_MODAL",
      span: 24,
      disabled: true,
      properties: {
        options: [],
        columns: () => [],
      },
    },
    {
      ref: "main_endjob_damage",
      name: "main_endjob_damage",
      id: "main_endjob_damage",
      label: "สาเหตุการเสีย",
      type: "TEXTAREA",
      span: 24,
      disabled: true,
    },
    {
      ref: "main_endjob_remark",
      name: "main_endjob_remark",
      id: "main_endjob_remark",
      label: "หมายเหตุ / คอมเมนต์",
      type: "TEXTAREA",
      span: 24,
      disabled: true,
    },
  ];
};
